import type { ReactNode } from 'react';

/* Sets the ambient per-engine accent scope. Everything inside inherits
 * --engine-accent / --engine-accent-wash from the [data-engine] rules in
 * tokens.css — the single swappable identity edge (brief §6.2, §6.5). */
export function EngineThemeProvider({
  engineKey,
  children,
  className,
}: {
  engineKey?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div data-engine={engineKey ?? undefined} className={className}>
      {children}
    </div>
  );
}
